import { Theme } from '@mui/material'

const useStyles = {
  formInputContainer: (theme: Theme) => ({
    width: '100%',
    marginBottom: theme.spacing(2),
  }),
  stickyBanner: {
    flexShrink: 0,
  },
  outerContainer: {
    flex: 1,
    minHeight: 0,
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  agreementContainer: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    gap: 2,
    marginX: 'auto',
    paddingX: '16px',
    paddingTop: 2,
  },
  errorContainer: {
    minHeight: '600px',
    marginX: 'auto',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
  },
  errorButtonRow: {
    gap: 2,
    marginTop: 1,
  },
  footerContainer: (theme: Theme) => ({
    flexShrink: 0,
    justifyContent: 'center',
    paddingY: '16px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.30)',
  }),
  footerContent: () => ({
    width: '100%',
    flexDirection: 'column',
    paddingX: '16px',
  }),
  signatureButtonRow: {
    width: '100%',
    justifyContent: 'space-between',
  },
}

export default useStyles
